function requestHeader(config, name) {
    const headers = config?.headers;
    if (!headers) return undefined;
    if (typeof headers.get === "function") return headers.get(name);

    const headerKey = Object.keys(headers)
        .find((key) => key.toLowerCase() === name.toLowerCase());
    return headerKey ? headers[headerKey] : undefined;
}

// Mirrors the backend AUTHENTICATED_USER_PATHS: these endpoints operate on the
// authenticated user regardless of the active workspace, so a stray workspace
// header must not misclassify them as workspace-scoped mutations.
const AUTHENTICATED_USER_MUTATION_PATHS = [
    "/users",
    "/user",
    "/updateUser",
    "/option-set",
    "/user-event-logs",
    "/create-workspace",
    "/workspace-onboarding",
    "/accept-workspace-invitation",
    "/user-sessions",
];

function isAuthenticatedUserMutationPath(path = "") {
    return AUTHENTICATED_USER_MUTATION_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export const isWorkspaceScopedMutation = (config = {}) => {
    const method = String(config.method || "get").toLowerCase();
    const workspaceHeader = requestHeader(config, "workspace");
    if (!["post", "put", "patch", "delete"].includes(method)
        || workspaceHeader === null
        || workspaceHeader === undefined
        || String(workspaceHeader).trim() === "") {
        return false;
    }
    if (isAuthenticatedUserMutationPath(requestPath(config))) return false;
    return true;
};

function requestPath(config = {}) {
    const raw = String(config.url || "").split("?")[0];
    const normalized = raw.replace(/^https?:\/\/[^/]+/i, "");
    return normalized.startsWith("/api/") ? normalized.slice(4) : normalized;
}

function requestData(config = {}) {
    if (config.data && typeof config.data === "object") return config.data?.data;
    if (typeof config.data !== "string") return undefined;

    try {
        return JSON.parse(config.data)?.data;
    } catch {
        return undefined;
    }
}

export const isOwnWorkspacePreferenceMutation = (config = {}) => {
    const method = String(config.method || "get").toLowerCase();
    const path = requestPath(config);
    const data = requestData(config);
    const fields = data && typeof data === "object" && !Array.isArray(data)
        ? Object.keys(data)
        : [];

    return ["put", "patch"].includes(method)
        && /^\/workspace-memberships\/[^/]+$/.test(path)
        && fields.length > 0
        && fields.every((field) => ["isDefault", "workspaceConfigs"].includes(field));
};

export const isWorkspaceMediaAccessMutation = (config = {}) => {
    const method = String(config.method || "get").toLowerCase();
    const path = requestPath(config);
    return method === "post" && /^\/workspace-media\/[^/]+\/access$/.test(path);
};
